import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Usuarios from './pages/Usuarios';
import Articulos from './pages/Articulos';
import UnidadesMedida from './pages/UnidadesMedida';
import TipoCambio from './pages/TipoCambio';
import TablaSimple from './pages/TablaSimple';
import Entidades from './pages/Entidades';
import Trabajadores from './pages/Trabajadores';
import Transportistas from './pages/Transportistas';
import Vehiculos from './pages/Vehiculos';
import GuiasRemision from './pages/GuiasRemision';
import GrDesdePe from './pages/GrDesdePe';
import GrDesdeRq from './pages/GrDesdeRq';
import DatosGenerales from './pages/DatosGenerales';
import Sucursales from './pages/Sucursales';
import Almacenes from './pages/Almacenes';
import Ubigeos from './pages/Ubigeos';
import FormasPago from './pages/FormasPago';
import Requerimientos from './pages/Requerimientos';
import AprobacionRQ from './pages/AprobacionRQ';
import SeguimientoDetalladoRQ from './pages/SeguimientoDetalladoRQ';
import OrdenesCompra from './pages/OrdenesCompra';
import OcDesdeRq from './pages/OcDesdeRq';
import ProximamentePage from './pages/ProximamentePage';
import ParteEntradaList from './pages/ParteEntradaList';
import ParteEntrada from './pages/ParteEntrada';
import ParteSalidaList from './pages/ParteSalidaList';
import Kardex from './pages/Kardex';
import CuentasContables from './pages/CuentasContables';
import SiscontConexiones from './pages/SiscontConexiones';
import Empresas from './pages/Empresas';
import ParteEntradaValorizado from './pages/ParteEntradaValorizado';
import PeDesdeOc from './pages/PeDesdeOc';
import PeDesdeGr from './pages/PeDesdeGr';
import PsDesdePe from './pages/PsDesdePe';
import ParteSalida from './pages/ParteSalida';
import ParteSalidaValorizada from './pages/ParteSalidaValorizada';
import TiposMovimiento from './pages/TiposMovimiento';
import Series from './pages/Series';
import SeriesModulos from './pages/SeriesModulos';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/utilitarios/usuarios" element={<PrivateRoute><Usuarios /></PrivateRoute>} />

          {/* Tablas Generales */}
          <Route path="/tablas/articulos" element={<PrivateRoute><Articulos /></PrivateRoute>} />
          <Route path="/tablas/unidades-medida" element={<PrivateRoute><UnidadesMedida /></PrivateRoute>} />
          <Route path="/tablas/tipo-cambio" element={<PrivateRoute><TipoCambio /></PrivateRoute>} />
          <Route path="/tablas/categorias" element={<PrivateRoute><TablaSimple tablaKey="categorias" /></PrivateRoute>} />
          <Route path="/tablas/marcas" element={<PrivateRoute><TablaSimple tablaKey="marcas" /></PrivateRoute>} />
          <Route path="/tablas/modelos" element={<PrivateRoute><TablaSimple tablaKey="modelos" /></PrivateRoute>} />
          <Route path="/tablas/familias" element={<PrivateRoute><TablaSimple tablaKey="familias" /></PrivateRoute>} />
          <Route path="/tablas/lineas" element={<PrivateRoute><TablaSimple tablaKey="lineas" /></PrivateRoute>} />
          <Route path="/tablas/grupos" element={<PrivateRoute><TablaSimple tablaKey="grupos" /></PrivateRoute>} />
          <Route path="/tablas/centros-costo" element={<PrivateRoute><TablaSimple tablaKey="centros-costo" /></PrivateRoute>} />
          <Route path="/tablas/tipos-existencia" element={<PrivateRoute><TablaSimple tablaKey="tipos-existencia" /></PrivateRoute>} />

          {/* Requerimientos */}
          <Route path="/requerimientos/listar" element={<PrivateRoute><Requerimientos /></PrivateRoute>} />
          <Route path="/requerimientos/aprobar" element={<PrivateRoute><AprobacionRQ /></PrivateRoute>} />
          <Route path="/requerimientos/seguimiento-detallado/:id" element={<PrivateRoute><SeguimientoDetalladoRQ /></PrivateRoute>} />

          {/* Órdenes de Compra */}
          <Route path="/orden-compra/listar" element={<PrivateRoute><OrdenesCompra /></PrivateRoute>} />
          <Route path="/orden-compra/desde-rq" element={<PrivateRoute><OcDesdeRq /></PrivateRoute>} />

          {/* Almacén — Partes de Entrada */}
          <Route path="/almacen/parte-entrada/listar"  element={<PrivateRoute><ParteEntradaList /></PrivateRoute>} />
          <Route path="/almacen/parte-entrada"         element={<PrivateRoute><ParteEntrada /></PrivateRoute>} />
          <Route path="/almacen/pe-valorizado"  element={<PrivateRoute><ParteEntradaValorizado /></PrivateRoute>} />
          <Route path="/almacen/pe-desde-oc"    element={<PrivateRoute><PeDesdeOc /></PrivateRoute>} />
          <Route path="/almacen/pe-desde-gr"    element={<PrivateRoute><PeDesdeGr /></PrivateRoute>} />
          <Route path="/almacen/pe-desde-gs"    element={<PrivateRoute><ProximamentePage titulo="PE desde GS" /></PrivateRoute>} />

          {/* Almacén — Partes de Salida */}
          <Route path="/almacen/parte-salida"        element={<PrivateRoute><ParteSalidaList /></PrivateRoute>} />
          <Route path="/almacen/parte-salida/nuevo"  element={<PrivateRoute><ParteSalida /></PrivateRoute>} />
          <Route path="/almacen/ps-valorizada"  element={<PrivateRoute><ParteSalidaValorizada /></PrivateRoute>} />
          <Route path="/almacen/ps-desde-pe"    element={<PrivateRoute><PsDesdePe /></PrivateRoute>} />
          <Route path="/almacen/ps-desde-rq"    element={<PrivateRoute><ProximamentePage titulo="PS desde Requerimiento" /></PrivateRoute>} />

          {/* Kardex */}
          <Route path="/kardex/movimientos" element={<PrivateRoute><Kardex /></PrivateRoute>} />
          <Route path="/kardex/consumo"     element={<PrivateRoute><Kardex modo="consumo" /></PrivateRoute>} />

          {/* Contabilidad */}
          <Route path="/contabilidad/cuentas-contables" element={<PrivateRoute><CuentasContables /></PrivateRoute>} />
          <Route path="/contabilidad/siscont-anios"      element={<PrivateRoute><SiscontConexiones /></PrivateRoute>} />

          {/* Almacén — Guías de Remisión */}
          <Route path="/almacen/guias-remision"      element={<PrivateRoute><GuiasRemision /></PrivateRoute>} />
          <Route path="/almacen/gr-desde-pe"         element={<PrivateRoute><GrDesdePe /></PrivateRoute>} />
          <Route path="/almacen/gr-desde-rq"         element={<PrivateRoute><GrDesdeRq /></PrivateRoute>} />

          {/* Entidades */}
          <Route path="/entidades/proveedores-clientes" element={<PrivateRoute><Entidades /></PrivateRoute>} />
          <Route path="/entidades/trabajadores" element={<PrivateRoute><Trabajadores /></PrivateRoute>} />
          <Route path="/entidades/transportistas" element={<PrivateRoute><Transportistas /></PrivateRoute>} />
          <Route path="/entidades/vehiculos" element={<PrivateRoute><Vehiculos /></PrivateRoute>} />

          {/* Utilitarios */}
          <Route path="/utilitarios/empresas"        element={<PrivateRoute><Empresas /></PrivateRoute>} />
          <Route path="/utilitarios/datos-generales" element={<PrivateRoute><DatosGenerales /></PrivateRoute>} />
          <Route path="/utilitarios/sucursales" element={<PrivateRoute><Sucursales /></PrivateRoute>} />
          <Route path="/utilitarios/almacenes" element={<PrivateRoute><Almacenes /></PrivateRoute>} />
          <Route path="/utilitarios/ubigeos" element={<PrivateRoute><Ubigeos /></PrivateRoute>} />
          <Route path="/utilitarios/formas-pago" element={<PrivateRoute><FormasPago /></PrivateRoute>} />
          <Route path="/utilitarios/areas" element={<PrivateRoute><TablaSimple tablaKey="areas" /></PrivateRoute>} />
          <Route path="/utilitarios/cargos" element={<PrivateRoute><TablaSimple tablaKey="cargos" /></PrivateRoute>} />
          <Route path="/utilitarios/prioridades" element={<PrivateRoute><TablaSimple tablaKey="prioridades" /></PrivateRoute>} />
          <Route path="/utilitarios/tipos-documento"   element={<PrivateRoute><TablaSimple tablaKey="tipos-documento" /></PrivateRoute>} />
          <Route path="/utilitarios/tipos-movimiento" element={<PrivateRoute><TiposMovimiento /></PrivateRoute>} />
          <Route path="/utilitarios/tipos-operacion"  element={<PrivateRoute><TablaSimple tablaKey="tipos-operacion" /></PrivateRoute>} />
          <Route path="/utilitarios/motivos-traslado" element={<PrivateRoute><TablaSimple tablaKey="motivos-traslado" /></PrivateRoute>} />
          <Route path="/utilitarios/series" element={<PrivateRoute><Series /></PrivateRoute>} />
          <Route path="/utilitarios/series-modulos" element={<PrivateRoute><SeriesModulos /></PrivateRoute>} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
